<router-outlet name="primary"></router-outlet>
